import React from "react";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

const SelectBox = ({ title, options, handleChange, value = "" }) => {
  return (
    <FormControl>
      <InputLabel>{title}</InputLabel>
      <Select onChange={handleChange} value={value}>
        <MenuItem value={""}>Selecione...</MenuItem>
        {options.map((value) => (
          <MenuItem key={value} value={value}>
            <span style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {value}
            </span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBox;
